export default __webpack_public_path__ + "static/media/pic1.66b4ef66.jpg";